import { ArrowLeft, ShieldOff } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import type { RootState } from "../../app/store";
import { getDefaultAuthenticatedPath } from "../../features/auth/defaultAuthenticatedPath";

export function UnauthorizedPage() {
	const navigate = useNavigate();
	const user = useSelector((state: RootState) => state.auth.user);

	return (
		<div className="flex min-h-[320px] items-center justify-center p-6">
			<div className="w-full max-w-md overflow-hidden rounded-2xl border border-border bg-bg-card shadow-sm">
				<div className="border-b border-border-light px-6 py-5">
					<div className="flex items-start gap-3">
						<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--color-role-homeowner-bg)] text-accent">
							<ShieldOff className="h-5 w-5" aria-hidden />
						</div>
						<div className="min-w-0">
							<h1 className="text-lg font-semibold text-primary">
								Access denied
							</h1>
							<p className="mt-1 text-sm leading-6 text-primary-muted">
								You don’t have permission to view this module. Contact your
								administrator if you believe this is a mistake.
							</p>
						</div>
					</div>
				</div>
				<div className="flex flex-wrap items-center justify-end gap-2 px-6 py-4">
					<button
						type="button"
						onClick={() =>
							navigate(getDefaultAuthenticatedPath(user), { replace: true })
						}
						className="inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white hover:opacity-90"
					>
						<ArrowLeft className="h-4 w-4" aria-hidden />
						Go to home
					</button>
				</div>
			</div>
		</div>
	);
}
